import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Workspace from "@/pages/Workspace";
import LoginScreen from "@/pages/LoginScreen";
import { AuthProvider, useAuth } from "@/lib/auth";

function Gate() {
  const { status } = useAuth();
  if (status === "checking") {
    return (
      <div className="w-full h-screen bg-black flex items-center justify-center text-[#00FF41] font-mono text-xs uppercase tracking-widest" data-testid="boot-screen">
        &gt; booting…
      </div>
    );
  }
  if (status === "anon") return <LoginScreen />;
  return <Workspace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Gate />} />
            <Route path="/p/:projectId" element={<Gate />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            borderRadius: 0,
            border: "1px solid #2D7544",
            background: "#050805",
            color: "#00FF41",
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "12px",
            letterSpacing: "0.05em",
          },
        }}
      />
    </div>
  );
}

export default App;
